export const CHECKING_RESTRICTED_IP_STAUTS = {
  TODO: "TODO",
  CHECKING: "CHECKING",
  PASSED: "PASSED",
  NOT_ALLOWED: "NOT_ALLOWED",
  CONNECT_FAILED: "CONNECT_FAILED",
};
